<template lang="pug">
  button.reset-btn.button.button_link.button_no-border.button_transparent(
    @click="showComplaintMessage"
  ) Я обнаружил несанкционированный объект размещения отходов
</template>

<script>
import * as L from 'leaflet'
import { MARKER_ICON } from '@/config/map'
import { unauthorized } from '@/api/api-endpoints'

export default {
  name: 'map-complaint',
  props: {
    map: Object,
  },
  data() {
    return {
      hasComplaintAction: false,
      complaintLayer: null,
      location: { lat: null, lng: null },
    }
  },
  methods: {
    showComplaintMessage() {
      this.hasComplaintAction = true
      this.addActionToMapClick()
      this.$notify.warning({
        title: `Укажите на карте обнаруженный вами несанкционированный объект обращения с отходами`,
      })
    },
    actionToClick(e) {
      if (!this.hasComplaintAction) {
        return false
      }
      if (this.complaintLayer) {
        this.map.removeLayer(this.complaintLayer)
      }
      this.location = e.latlng
      this.complaintLayer = L.marker(this.location, {
        icon: MARKER_ICON,
      })
      const popup = L.popup({
        offset: [0, -30],
      })
        .setLatLng(this.location)
        .setContent(this.addContentToPopup(this.location))
        .openOn(this.map)
      this.complaintLayer.bindPopup(popup)
      this.map.addLayer(this.complaintLayer)
    },
    addActionToMapClick() {
      this.map.addEventListener('click', this.actionToClick)
    },
    addContentToPopup() {
      return `<div class='map-popup'>
                <div class='map-popup__header'>
                    <div class='map-popup__title'>Подтвердите выбор</div>
                </div>
                 <div class='map-popup__body'>
                  <p>Вы указали место несанкционированного ОРО, данное обращение поможет нам исправить ситуацию</p>
                  <div class='tooltip__body-item'>
                    <span class='info info--grey'>Координаты:</span>
                    <span class='info'>${this.location.lat}, ${this.location.lng}</span>
                  </div>
                 </div>
                 <div class='map-popup__footer'>
                   <div class='map-popup__buttons'>
                     <button class='reset-btn button map-popup__button button_warning js-cancel-choice'>Отменить</button>
                     <button class='reset-btn button map-popup__button js-select-object'
                     data-latitude='${this.location.lat}'
                     data-longitude='${this.location.lng}'
                     >Потвердить</button>
                   </div>
                 </div>
               </div>`
    },
    addActionsToPopup() {
      document.addEventListener('click', this.actionsToPopup)
    },
    actionsToPopup(e) {
      if (e.target.classList.contains('js-cancel-choice')) {
        if (this.complaintLayer) {
          this.map.removeLayer(this.complaintLayer)
        }
        this.hasComplaintAction = false
      }
      if (e.target.classList.contains('js-select-object')) {
        const latitude = e.target.dataset.latitude
        const longitude = e.target.dataset.longitude
        this.setComplaint(latitude, longitude)
      }
    },
    async setComplaint(latitude, longitude) {
      await this.$store.dispatch('createModel', {
        url: unauthorized.complaint(),
        data: {
          latitude,
          longitude,
        },
      })
      this.$notify.success({
        title: `Обращение отправлено`,
      })
      this.map.removeLayer(this.complaintLayer)
      this.hasComplaintAction = false
    },
  },
  mounted() {
    this.addActionsToPopup()
  },
  destroyed() {
    document.removeEventListener('click', this.actionsToPopup)
  },
}
</script>
